import React from "react";
import "./bannervideo.css";
import {
  MEDIA_LINKS,
  SCHOOL_PROGRAM_PDF,
  COMMON_THUMBNAIL_URL,
} from "../../../Constants/mediaLinks";

export default function BannerVideo() {
  return (
    <>
      <div className="bv-wrapper">
        <div className="bv-card-container">
          <div className="bv-inner">
            <div className="bv-text-section">
              <p style={{backgroundColor: "black"}} className="black-text-clip">
                BWC is a licensed DOE vendor with over 5 years of experience
                working within the NYC school system. We have served thousands
                of students each in both public and private schools, our DOE
                Vendor is #BEC214306.
              </p>
              <div className="bv-btn-box">
                <a
                  href={SCHOOL_PROGRAM_PDF}
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <button className="bv-watch-btn">
                    DOWNLOAD SCHOOL PROGRAMS "PDF"
                  </button>
                </a>
              </div>
            </div>
            <div className="bv-video-placeholder">
              <div
                className="responsive-youtube-video"
                style={{ paddingBottom: "56.25%" }}
              >
                <video
                  controls
                  autoPlay
                  muted
                  poster={MEDIA_LINKS.FIELD_DAYS.VIDEO}
                  style={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    borderRadius: "12px",
                    objectFit: "cover",
                  }}
                >
                  <source src={MEDIA_LINKS.FIELD_DAYS.VIDEO} type="video/mp4" />
                  Your browser does not support the video tag.
                </video>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}
